export enum orderSummaryEvents {
    removeProduct = 'OrderSummary-removeProduct',
    updateCouponCode = 'OrderSummary-updateCouponCode',
    releaseCouponCode = 'OrderSummary-releaseCouponCode',
    toggleText = 'OrderSummary-toggleText',
    setPricingEngineResponse = 'OrderSummary-setPricingEngineResponse',
    setPreOrder = 'OrderSummary-setPreOrder',
    showPaymentForm = 'OrderSummary-showPaymentForm'
}

export enum couponCodeEvents {
    getProductsData = 'CouponCode-getProductsData',
    setCouponCode = 'CouponCode-setCouponCode',
    releaseCouponCode = 'CouponCode-releaseCouponCode'
}

export enum orderConfirmationEvents {
    getActivationResquestData = 'OrderConfirmation-getActivationResquestData',
}

export const upgradePGKs = ['D29C9CBC', '1ED00405', '51BA0113', '278B0F6A',
    '42BB4EFC', '37EEF2CC', '4613D2D7']

export enum productDetailsEvents{
    addProduct = 'ProductDetails-addProduct',
    removeProduct = 'ProductDetails-removeProduct',
    selectDevice = 'ProductDetails-selectDevice',
    continueToBillingInfo = 'ProductDetails-continueToBillingInfo',
    setProductInformation = 'ProductDetails-setProductInformation',
    setRecommendedProductsInformation = 'ProductDetails-setRecommendedProductsInformation',
    setAutoRenewal = 'ProductDetails-setAutoRenewal',
    toggleAutoRenewal = 'ProductDetails-toggleAutoRenewal',
    setAutoRenewalInformation = 'ProductDetails-setAutoRenewalInformation',
    setDeviceProductsInformation = 'ProductDetails-setDeviceProductsInformation',
    setPriceGroupKey = 'ProductDetails-setPriceGroupKey',
    validatePriorYear = 'ProductDetails-validatePriorYear',
    noFreeTisOption = 'ProductDetails-noFreeTisOption'
}

export enum billingAndPaymentEvents{
    setBillingInformation = 'setBillingInformation',
    setShippingInformation = 'setShippingInformation',
    setPaymentInformation = 'setPaymentInformation',
    setPaymentMaskedInformation = 'setPaymentMaskedInformation',
    continueToOrderConfirmation = 'continueToOrderConfirmation',
    setTransactionUuid = 'setTransactionUuid',
    setPricingEngineResponse = "BillingAndPayment-setPricingEngineResponse"
}

export enum nuDataEvents {
    couponCodeMicroLoaded = 'couponCodeMicroLoaded',
    billingAndPaymentFieldLoaded = 'billingAndPaymentFieldLoaded'
}

export enum microUI {
    orderSummary = 'orp-micro-order-summary',
    productDetails = 'orp-micro-product-details',
    billingAndPayment = 'orp-micro-billing-and-payment',
    couponCode = 'orp-micro-apply-discount',
    orderConfirmation = 'orp-micro-order-confirmation'
}

export enum eventActions {
    removeProduct = 'removeProduct',
    addProduct = 'addProduct',
    selectDevice = 'selectDevice',
    orderSummaryProduct = 'orderSummaryProduct',
    productInfo = 'productInfo',
    recommendedProductsInfo = 'recommendedProductsInfo',
    deviceTypeInfo = 'deviceTypeInfo',
    billingInfo = 'billingInfo',
    billingInfoEmail = 'billingInfoEmail',
    shippingInfo = 'shippingInfo',
    backUpCdInfo = 'data',
    paymentInfo = 'paymentInfo',
    terms = 'terms',
    productsDiscount = 'productsDiscount',
    couponCodeDiscount = 'couponCodeDiscount',
    couponReleaseCode = 'couponReleaseCode',
    updateCouponCode = 'updateCouponCode',
    service = 'service',
    base_url = 'base_url',
    tax_year = 'tax_year',
    client_ip = 'client_ip',
    summary_mode = 'summary_mode',
    melissa_data = 'melissa_data',
    payment_mode = 'payment_mode',
    sku = 'sku',
    state = 'state',
    promocode = 'promocode',
    price_group_key = 'price_group_key',
    validateDevice = 'validateDevice',
    orderbillingInfo = 'setbillingInfo',
    setOrderConfirmation = 'setOrderConfirmation',
    setAutoRenewal = 'setAutoRenewal',
    autoRenewalChecked = 'autoRenewalChecked',
    autoRenewalInformation = 'autoRenewalInformation',
    deviceProductsInfo = 'deviceProductsInfo',
    activationCode = 'activationCode',
    orderSummaryResponse = 'orderSummaryResponse',
    preOrderDate = 'preOrderDate',
    showPaymentForm = 'showPaymentForm',
    transactionUuid = 'transactionUuid',
    devices_available = 'devices_available',
    sourceOfOperation = 'nuDataSourceOfOperation',
    product = 'product',
    productAddons = 'productAddons',
    prior_tax_year = 'prior_tax_year',
    taxYear = 'taxYear',
    emailRequired = 'emailRequired',
    zipCodePlusFourValidation = 'zipCodePlusFourValidation',
    noFreeTisOption ='noFreeTisOption'
}

export enum termsAndConditionsInfo {
    showAutoRenewalTerms = 'showAutoRenewalTerms',
    showTaxIdentityShieldTerms = 'showTaxIdentityShieldTerms',
    showBothTerms = 'showBothTerms'
}

export enum ISourceOfOperation {
  remotePaymentPortal = 'RemotePaymentPortal',
  softwareCart = 'SoftwareCart'
}
